<template>
	<div class="prizes-control">
		<div v-for="(group, index) in value" :key="index" :class="[`prizes-day-${index + 1}`]">
			<div class="form-group row">
				<div class="col-md-12">
					<h3 class="prizes-title">Prize {{ index + 1 }}</h3>
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Title-${index + 1}`">Title*</label>
				<div class="col-md-10">
					<input type="text" class="form-control" v-model="group.name" />
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Sponsor-${index + 1}`">Sponsor</label>
				<div class="col-md-10">
					<input type="text" class="form-control" v-model="group.sponsor" />
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Description-${index + 1}`">Description</label>
				<div class="col-md-10">
					<textarea type="text" class="form-control" rows="4" v-model="group.description" />
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Value-${index + 1}`">Value*</label>
				<div class="col-md-10">
					<input type="number" step="0.01" class="form-control" v-model="group.value" />
				</div>
			</div>
			<div class="form-group row">
				<label class="form-label col-md-2" :for="`Image-${index + 1}`">Image*</label>
				<div class="col-md-10">
					<ImageUploadButton
						ref="imageUploaderPrizes"
						:imageUrl="group && group.images ? group.images : ''"
						@clear="onClearUploadImage(index)"
					/>
				</div>
			</div>
		</div>
		<AddContentButton color="#C32AA3" @click="onClickAddPrizes">Add Prize</AddContentButton>
	</div>
</template>

<script>
import AddContentButton from '@/components/AddContentButton';
import ImageUploadButton from '@/components/ImageUploadButton';
export default {
	components: {
		AddContentButton,
		ImageUploadButton,
	},
	props: {
		value: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	methods: {
		onClickAddPrizes() {
			this.value.push({
				name: '',
				sponsor: '',
				description: '',
				value: '',
				images: [],
			});
		},
		onClearUploadImage(index) {
			this.value[index].images = '';
		},
		async uploadImages() {
			const urls = [];
			if (this.$refs.imageUploaderPrizes && this.$refs.imageUploaderPrizes.length > 0) {
				for (let i = 0, n = this.$refs.imageUploaderPrizes.length; i < n; i++) {
					const files = await this.$refs.imageUploaderPrizes[i].upload();
					let fileUrl = '';
					if (files && files.length > 0) {
						fileUrl = files[0].url;
					}

					urls.push(fileUrl);
				}
			}
			return urls;
		},
	},
};
</script>

<style lang="scss">
.prizes-control {
	.prizes-title {
		color: #c32aa3;
		font-size: 1.125rem;
		font-weight: bold;
	}

	.form-control {
		border-radius: 0;
	}

	.delete-instance {
		font-size: 1.125rem;
		cursor: pointer;
	}
	.btn-prize {
		background-color: #c32aa3;
		border: #c32aa3;
		border-radius: 4px;
	}
}
</style>
